import { render, staticRenderFns } from "./marquee.vue?vue&type=template&id=2f211412&scoped=true&"
import script from "./marquee.vue?vue&type=script&lang=ts&"
export * from "./marquee.vue?vue&type=script&lang=ts&"
import style0 from "./marquee.vue?vue&type=style&index=0&id=2f211412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f211412",
  null
  
)

export default component.exports